import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["value", "disabled", "onClick"]

import { i18n } from '@/i18n';
import { OrderGroupMenuItems, ORDER_GROUP_MENU_HEIGHT } from '../../constants';
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import { watch } from 'vue';
import TextIconButton from '@/corePagesModule/components/TextIconButton.vue';
import { useOrderTableStore } from '../../pages/useOrderTableStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderGroupMenuDropdown',
  setup(__props) {

const t = i18n.t;
const isOpen = ref(false);
const orderGroupContainerRef = ref<HTMLDivElement | null>(null);
const orderGroupDropdownRef = ref<HTMLDivElement | null>(null);

const store = useOrderTableStore();
const { state } = store;

const isOrderGroupAddAvailable = computed(() => state.checkedIds.length > 0);

watch(isOpen, (newVal) => {
  if (newVal) {
    calculateDropdownPosition();
  }
});

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!isOpen.value || !orderGroupContainerRef.value || !orderGroupDropdownRef.value) return;
  const path = event.composedPath() as EventTarget[];
  if (!(path.includes(orderGroupContainerRef.value) || path.includes(orderGroupDropdownRef.value))) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.addEventListener('click', closeDropdown);
});

/**
 * ドロップダウンの位置を計算し、設定します。
 */
const calculateDropdownPosition = () => {
  nextTick(() => {
    if (!(orderGroupContainerRef.value && orderGroupDropdownRef.value)) return;
    const rect = orderGroupContainerRef.value.getBoundingClientRect();
    const dropdown = orderGroupDropdownRef.value;
    dropdown.style.left = `${rect.left}px`;
    dropdown.style.top = `${rect.bottom}px`;

    // ドロップダウンの高さを計算
    const desiredHeight = ORDER_GROUP_MENU_HEIGHT * Object.keys(OrderGroupMenuItems).length;

    // max-heightを計算して設定
    const availableHeight = window.innerHeight - rect.bottom - 10; // 10pxは少しのマージン
    dropdown.style.maxHeight = `${Math.min(desiredHeight, availableHeight)}px`;
  });
};

/**
 * 選択肢をクリックした場合の処理
 * @param option - 選択された項目
 */
const onClickOption = async (option: OrderGroupMenuItems) => {
  isOpen.value = false;
  state.orderGroupState.openingModal = option;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "order-group-menu_container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDropdown($event)))
  }, [
    _createElementVNode("div", {
      ref_key: "orderGroupContainerRef",
      ref: orderGroupContainerRef,
      class: "order-group-menu"
    }, [
      _createVNode(TextIconButton, {
        text: _unref(t)('発注グループ'),
        icon: isOpen.value ? 'arrowUpBlue' : 'arrowDownBlue',
        "color-style": "secondary",
        onClick: toggleDropdown
      }, null, 8, ["text", "icon"]),
      (isOpen.value)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: "body"
          }, [
            _createElementVNode("div", {
              ref_key: "orderGroupDropdownRef",
              ref: orderGroupDropdownRef,
              class: "order-group-menu__dropdown"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OrderGroupMenuItems), (option, key) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: key,
                  class: _normalizeClass(["order-group-menu__option", { 'order-group-menu__option--disabled': option === _unref(OrderGroupMenuItems).OrderGroupAdd && !isOrderGroupAddAvailable.value }]),
                  value: option,
                  disabled: option === _unref(OrderGroupMenuItems).OrderGroupAdd && !isOrderGroupAddAvailable.value,
                  onClick: () => onClickOption(option)
                }, _toDisplayString(_unref(t)(option)), 11, _hoisted_1))
              }), 128))
            ], 512)
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}
}

})